import { useQuery } from '@tanstack/react-query';
import { api } from './api';

/**
 * Which build this is: GET /api/id/meta. `env` drives the dev ribbon (EnvBadge, from the shared
 * package once it exists) and the "[dev]" title prefix; `version`/`commit` are Heroku's release
 * number and slug commit, null on the laptop. Fetched once per page load; it cannot change
 * underneath a running tab.
 */
export type Meta = {
  app: 'hub' | 'qa' | 'academy';
  env: 'local' | 'dev' | 'production';
  version: string | null;
  commit: string | null;
};

export function useMeta() {
  return useQuery({
    queryKey: ['meta'],
    queryFn: () => api.get<Meta>('/api/id/meta'),
    staleTime: Infinity,
    retry: false,
  });
}
